export const Calendar = ({ color }) => {
	return (
		<div className="counterItem">
			<svg
				id="calendar"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 767.22 821.39"
			>
				<rect
					style={{ fill: color }}
					x="131.45"
					y="358.71"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="268.46"
					y="358.71"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="405.47"
					y="358.71"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="542.47"
					y="358.71"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="131.45"
					y="493.68"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="268.46"
					y="493.68"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="405.47"
					y="493.68"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="542.47"
					y="493.68"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="131.45"
					y="637.44"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="268.46"
					y="637.44"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="405.47"
					y="637.44"
					width="94.77"
					height="94.77"
					rx="21.8"
					ry="21.8"
				/>
				<rect
					style={{ fill: color }}
					x="154"
					y="0"
					width="62.25"
					height="197.57"
					rx="31.13"
					ry="31.13"
				/>
				<rect
					style={{ fill: color }}
					x="538.08"
					y="0"
					width="62.25"
					height="197.57"
					rx="31.13"
					ry="31.13"
				/>
				<path
					style={{ fill: color }}
					d="M709.76,92.62H57.46C25.73,92.62,0,118.34,0,150.08V763.93c0,31.73,25.73,57.46,57.46,57.46H709.76c31.73,0,57.46-25.73,57.46-57.46V150.08c0-31.73-25.73-57.46-57.46-57.46Zm-140.55,27.09c25.62,0,46.39,20.77,46.39,46.39s-20.77,46.39-46.39,46.39-46.39-20.77-46.39-46.39,20.77-46.39,46.39-46.39Zm-384.08,0c25.62,0,46.39,20.77,46.39,46.39s-20.77,46.39-46.39,46.39-46.39-20.77-46.39-46.39,20.77-46.39,46.39-46.39ZM721.8,387.91v353.4c0,18.94-15.36,34.3-34.3,34.3H79.71c-18.94,0-34.3-15.36-34.3-34.3V302.73H721.8v85.17Z"
				/>
			</svg>
			<p style={{ color }}>Book a meeting</p>
		</div>
	);
};
